<template>
  <div id="working-hour">
    <!-- <vs-table id="working-hour" ref="table" multiple v-model="selected" :data="days">
        <template slot="thead">
            <vs-th class="font-normal text-base">Everyday</vs-th>
            <vs-th><vs-button type="border" color="primary" class="ml-auto" @click="setWorkingHour">Set working hours default</vs-button></vs-th>
        </template>

        <template>
        <tbody>
            <vs-tr :data="day" v-for="(day, index) in days" :key="index">
                <vs-td>{{day}}</vs-td>
                <vs-td class="flex justify-end">
                    <span class="d-inline-block mr-6">In <span class="d-inline-block ml-2 text-2xl">08:30 AM</span></span>
                    <span>Out <span class="d-inline-block ml-2 text-2xl">16:30 PM</span></span>
                </vs-td>
            </vs-tr>

        </tbody>
        </template>
    </vs-table>-->
    <template>
      <div class="flex justify-end mb-6">
        <vs-button type="border" color="primary" @click="editWorkingHour">Edit</vs-button>
        <!-- <vs-button color="primary" class="ml-6">Set working hours default</vs-button> -->
      </div>
    </template>

    <div class="flex mb-2">
      <div class="w-1/3"></div>
      <div class="flex w-2/3 font-bold">
        <div class="w-1/2 text-center">IN</div>
        <div class="w-1/2 text-center">OUT</div>
      </div>
    </div>
    <vx-card class="mb-5 overflow-hidden md:p-0 p-5" v-for="(day, index) in days" :key="index">
      <template slot="no-body">
        <div class="item-details no-gutter p-5 md:flex align-center">
          <div class="md:w-1/3 flex w-full md:justify-start justify-center">
            <div v-if="day.active">
              <feather-icon icon="CheckIcon" svgClasses="w-6 h-6 stroke-current text-success mr-6" />
            </div>
            <div v-else>
              <feather-icon icon="XIcon" svgClasses="w-6 h-6 stroke-current text-danger mr-6" />
            </div>
            {{day.title}}
          </div>
          <div class="md:w-2/3 md:flex w-full justify-end hour-color text-center md:text-left" :class="{'active-hour': isActive(working_day, day.value)}">
            <span class="w-1/2 mr-6 text-center">
              <!-- In -->
              <span class="d-inline-block ml-2 text-xl">{{formatTime(day.time[0])}}</span>
            </span>
            <span class="w-1/2 text-center">
              <!-- Out -->
              <span class="d-inline-block ml-2 text-xl">{{formatTime(day.time[1])}}</span>
            </span>
          </div>
        </div>
      </template>
    </vx-card>

    <vs-popup class="working-hour-popup" title="Edit Working Hour" :active.sync="openEditPopup">
      <!-- <h1 class="text-center py-6">EDIT WORKING HOUR</h1> -->
      <div class="flex justify-end my-4 mx-6">
        <vs-button color="primary" class="ml-6 gradient gradient-primary no-shadow" @click="getBookingWorkingHour">Set working hours default</vs-button>
      </div>
      <div class="overflow-hidden">
        <div class="w-full overflow-auto">
          <div style="min-width: 650px;">
            <div class="flex py-3 border border-solid border-dark border-t-0 border-r-0 border-l-0 mx-6">
              <div class="w-1/6 text-uppercase font-bold text-center">Day</div>
              <div class="w-1/3 text-uppercase font-bold text-center">In time</div>
              <div class="w-1/3 text-uppercase font-bold text-center">Out Time</div>
              <div class="w-1/6 text-uppercase font-bold text-center">Active</div>
            </div>
            <div v-for="(day, index) in days_temp" :key="index" class="m-6">
              <div class="flex align-center">
                <div class="w-1/6 text-uppercase font-bold">{{day.title}}</div>
                <!-- <div class="w-1/4" :class="{'inactive': !day.active}">{{day.title}}</div> -->
                <div class="w-1/3 flex justify-center" :class="{'is-invalid' : day.hasErr, 'inactive': !day.active}">
                  <!-- <flat-pickr
                    :config="configdateTimePicker"
                    v-model="day.time[0]"
                    :key="days.value"
                    @on-change="setInTime($event, day)"
                    :max="12"
                    v-validate="{required:true}" :name="day.time[0]"
                  /> -->
                  <vue-timepicker format="hh:mm A" v-model="day.time[0]" :key="days.value" @on-change="setInTime($event, day)" v-validate="{required:true}" :name="day.time[0]"></vue-timepicker>
                </div>
                <div class="w-1/3 flex justify-center" :class="{'is-invalid': day.hasErr, 'inactive': !day.active}">
                  <!-- <flat-pickr
                    :config="configdateTimePicker"
                    v-model="day.time[1]"
                    :key="days.value"
                    @on-change="setOutTime($event, day)"
                    :max="12"
                    v-validate="{required:true}" :name="day.time[1]"
                  /> -->
                  <vue-timepicker format="hh:mm A" v-model="day.time[1]" :key="days.value" @on-change="setOutTime($event, day)" v-validate="{required:true}" :name="day.time[1]"></vue-timepicker>
                </div>

                <!-- <div :class="{'is-invalid' : errors.has('date')}">
                  <flat-pickr v-model="date" v-validate="{required:true}" name="date" placeholder="Select a date">
                  </flat-pickr>
                </div> -->
                <div class="w-1/6 flex justify-center" @click="changeStatus(day)">
                  <!-- <div v-if="isActive(working_day_temp, day.value)">
                    <feather-icon
                      icon="CheckIcon"
                      svgClasses="w-6 h-6 stroke-current text-success mr-6"
                    />
                  </div>
                  <div v-else>
                    <feather-icon icon="XIcon" svgClasses="w-6 h-6 stroke-current text-danger mr-6" />
                  </div>-->
                  <vs-switch v-model="day.active" @click="switchActive(day)" />
                </div>
              </div>
            </div>
            <div class="mx-6 mb-4">
              <div class="flex align-center">
                <div class="w-1/6"></div>
                <div class="w-1/3 flex justify-center"><vs-button type="filled" color="primary" style="width: 13em" @click="saveChanges">Save</vs-button></div>
                <div class="w-1/3 flex justify-center"><vs-button type="border" color="danger" style="width: 13em" @click="closePopup">Cancel</vs-button></div>
              </div>
            </div>
            <!-- <div class="flex py-6 mx-6" style="padding-left: calc(100% / 6);">
              <div class="w-1/3 flex justify-end">
                <vs-button type="filled" color="primary" style="width: 13em" @click="saveChanges">Save</vs-button>
              </div>
              <div class="w-1/3 flex justify-end">
                <vs-button type="border" color="danger" style="width: 13em" @click="closePopup">Cancel</vs-button>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import flatPickr from "vue-flatpickr-component";
import VueTimepicker from 'vue2-timepicker'
import "flatpickr/dist/flatpickr.css";
import moment from "moment";

export default {
  name: "working-hour",
  components: {
    flatPickr,
    VueTimepicker
  },
  props: {
    workingHourData: {
      type: Object,
    },
    activeStaffData: {
      type: Object,
      required: true
    }
  },
  data() {
    // console.log(this.workingHourData);
    // let working_day = this.workingHourData.working_day ? this.workingHourData.working_day : '';
    // let working_day_temp = working_day;
    // let days = [
    //   {
    //     title: "Monday",
    //     time: [
    //       this.getInTime(this.workingHourData.mo),
    //       this.getOutTime(this.workingHourData.mo)
    //     ],
    //     value: 1,
    //     active: this.isActive(working_day, 1)
    //   },
    //   {
    //     title: "Tuesday",
    //     time: [
    //       this.getInTime(this.workingHourData.tu),
    //       this.getOutTime(this.workingHourData.tu)
    //     ],
    //     value: 2,
    //     active: this.isActive(working_day, 2)
    //   },
    //   {
    //     title: "Wednesday",
    //     time: [
    //       this.getInTime(this.workingHourData.we),
    //       this.getOutTime(this.workingHourData.we)
    //     ],
    //     value: 3,
    //     active: this.isActive(working_day, 3)
    //   },
    //   {
    //     title: "Thursday",
    //     time: [
    //       this.getInTime(this.workingHourData.th),
    //       this.getOutTime(this.workingHourData.th)
    //     ],
    //     value: 4,
    //     active: this.isActive(working_day, 4)
    //   },
    //   {
    //     title: "Friday",
    //     time: [
    //       this.getInTime(this.workingHourData.fr),
    //       this.getOutTime(this.workingHourData.fr)
    //     ],
    //     value: 5,
    //     active: this.isActive(working_day, 5)
    //   },
    //   {
    //     title: "Saturday",
    //     time: [
    //       this.getInTime(this.workingHourData.sa),
    //       this.getOutTime(this.workingHourData.sa)
    //     ],
    //     value: 6,
    //     active: this.isActive(working_day, 6)
    //   },
    //   {
    //     title: "Sunday",
    //     time: [
    //       this.getInTime(this.workingHourData.su),
    //       this.getOutTime(this.workingHourData.su)
    //     ],
    //     value: 0,
    //     active: this.isActive(working_day, 0)
    //   }
    // ];

    // let days_temp = JSON.parse(JSON.stringify(days));
    return {

      // isLoaded,
      selected: [],
      working_day: '',
      working_day_temp: '',
      days: [],
      days_temp: [],
      openEditPopup: false,
      in_time: null,
      out_time: null,
      configdateTimePicker: {
        enableTime: true,
        enableSeconds: false,
        noCalendar: true,
        dateFormat: "G:i K",
      },
      date: null,
      hasErr: false,
      isOpenLoading: false
    };
  },
  watch: {
    openEditPopup: {
      immediate: true,
      deep: true,
      handler() {
        this.days_temp = JSON.parse(JSON.stringify(this.days));
        this.errors.clear();
        if(this.openEditPopup) {
          document.body.classList.add('overflow-hidden');
          document.body.style.position = '';
          document.body.style.top = '';
          window.scrollTo(0, parseInt(scrollY || '0') * -1);
        } else {
          this.getData();
          document.body.classList.remove('overflow-hidden');
        }
      }
    },
    workingHourData: {
      immediate: true,
      deep: true,
      handler() {
        this.getData();
      }
    }
  },

  methods: {
    openLoadingInDiv() {
      this.$vs.loading({
        container: '#app',
        scale: 0.8
      })
    },
    closeLoading() {
      this.$vs.loading.close('#app > .con-vs-loading');
    },
    getData() {
      this.working_day = this.getWorkingDay(this.workingHourData);
      this.days = this.getDays(this.workingHourData);
      this.getWorkingHourDataTemp(this.working_day, this.days);
    },
    getWorkingHourDataTemp(working_day, days) {
      this.working_day_temp = working_day;
      this.days_temp = JSON.parse(JSON.stringify(days));
    },
    getWorkingDay(workingHourData) {
      return workingHourData.working_day ? workingHourData.working_day : '';
    },
    getDays(workingHourData) {
      let working_day = workingHourData.working_day ? workingHourData.working_day : '';
      let days = [
        {
          title: "Monday",
          time: [
            this.getInTime(workingHourData.mo),
            this.getOutTime(workingHourData.mo)
          ],
          value: 1,
          active: this.isActive(working_day, 1),
          hasErr: false,
        },
        {
          title: "Tuesday",
          time: [
            this.getInTime(workingHourData.tu),
            this.getOutTime(workingHourData.tu)
          ],
          value: 2,
          active: this.isActive(working_day, 2),
          hasErr: false,
        },
        {
          title: "Wednesday",
          time: [
            this.getInTime(workingHourData.we),
            this.getOutTime(workingHourData.we)
          ],
          value: 3,
          active: this.isActive(working_day, 3),
          hasErr: false,
        },
        {
          title: "Thursday",
          time: [
            this.getInTime(workingHourData.th),
            this.getOutTime(workingHourData.th)
          ],
          value: 4,
          active: this.isActive(working_day, 4),
          hasErr: false,
        },
        {
          title: "Friday",
          time: [
            this.getInTime(workingHourData.fr),
            this.getOutTime(workingHourData.fr)
          ],
          value: 5,
          active: this.isActive(working_day, 5),
          hasErr: false,
        },
        {
          title: "Saturday",
          time: [
            this.getInTime(workingHourData.sa),
            this.getOutTime(workingHourData.sa)
          ],
          value: 6,
          active: this.isActive(working_day, 6),
          hasErr: false,
        },
        {
          title: "Sunday",
          time: [
            this.getInTime(workingHourData.su),
            this.getOutTime(workingHourData.su)
          ],
          value: 0,
          active: this.isActive(working_day, 0),
          hasErr: false,
        }
      ];
      return days;
    },
    formatTime(time) {
      let temp = time;
      if(time) {
        if(time.includes('AM') && parseInt(time.split(":")[0]) == 12) {
          // temp = '00:' + (parseInt(time.split(":")[1]) > 9 ? parseInt(time.split(":")[1]) : ('0' + parseInt(time.split(":")[1]))) + ' AM';
          temp = '12:' + (parseInt(time.split(":")[1]) > 9 ? parseInt(time.split(":")[1]) : ('0' + parseInt(time.split(":")[1]))) + ' AM';
        }
        if(time.includes('PM') && parseInt(time.split(":")[0]) == 12) {
          temp = '12:' + (parseInt(time.split(":")[1]) > 9 ? parseInt(time.split(":")[1]) : ('0' + parseInt(time.split(":")[1]))) + ' PM';
        }
      }
      return temp;
    },
    getBookingWorkingHour() {
      this.openLoadingInDiv();
      this.$store.dispatch("appSetting/GET_BOOKING_WORK_HOUR", {type: 'booking'}).then(() => {
        let working_day = this.getWorkingDay(this.$store.getters['appSetting/bookingWorkingHour']);
        let days = this.getDays(this.$store.getters['appSetting/bookingWorkingHour']);
        this.getWorkingHourDataTemp(working_day, days);
        this.closeLoading();
      }).catch((err) => {
        console.log('Error: ', err);
        this.closeLoading();
        this.$vs.dialog({
          color: 'danger',
          title: 'Notification',
          text: 'Get Booking Hours Failed',
          acceptText: 'OK'
        })
      })
      // let working_day = this.getWorkingDay(this.$store.getters['appSetting/bookingWorkingHour']);
      // let days = this.getDays(this.$store.getters['appSetting/bookingWorkingHour']);

      // this.getWorkingHourDataTemp(working_day, days);
    },
    getMinute(time){
      let in_minute = parseInt(time.split(":")[0]) * 60 + parseInt(time.split(":")[1]);
      if(time.includes('AM') && parseInt(time.split(":")[0]) == 12) {
        in_minute = parseInt(time.split(":")[1]);
      }
      if(time.includes('PM')) {
        if(parseInt(time.split(":")[0]) == 12) {
          in_minute = parseInt(time.split(":")[0]) * 60 + parseInt(time.split(":")[1]);
        } else {
          in_minute = (parseInt(time.split(":")[0]) + 12) * 60 + parseInt(time.split(":")[1]);
        }
      }
      return in_minute;
    },
    checkTimeInADay(day){
      if(this.getMinute(day.time[0]) >= this.getMinute(day.time[1])){
        return false
      }
      return true;
    },
    checkValidTime(){
      for(let i = 0; i < this.days_temp.length; i++){
        if(!this.checkTimeInADay(this.days_temp[i])){
          this.days_temp[i].hasErr = true;
          this.hasErr = true;
        }else{
          this.days_temp[i].hasErr = false;
        }
      }
    },
    checkTime(t) {
      return t > 9 ? "" + t : "0" + t;
    },
    // getInTime(time) {
    //   let num = parseInt(time.split(",")[0]);
    //   let hour = this.checkTime(Math.floor(num / 60));
    //   let minute = this.checkTime(num % 60);
    //   let in_time = hour + ":" + minute;
    //   return in_time;
    // },
    // getOutTime(time) {
    //   let num = parseInt(time.split(",")[1]);
    //   let hour = this.checkTime(Math.floor(num / 60));
    //   let minute = this.checkTime(num % 60);
    //   let out_time = hour + ":" + minute;
    //   return out_time;
    // },
    getInTime(time) {
      let num = 0;
      if(time) {
        num = parseInt(time.split(",")[0]);
      }
      let hour = 0;
      let A = "AM";
      if(Math.floor(num / 60) > 12) {
        hour = this.checkTime(Math.floor(num / 60) - 12);
        A = "PM";
      } else {
        if(Math.floor(num / 60) == 0) {
          hour = 12;
        } else if(Math.floor(num / 60) == 12) {
          hour = 12;
          A = "PM";
        } else {
          hour = this.checkTime(Math.floor(num / 60));
        }
      }
      let minute = this.checkTime(num % 60);
      let in_time = hour + ":" + minute + " " + A;
      return in_time;
    },
    getOutTime(time) {
      let num = 1;
      if(time) {
        num = parseInt(time.split(",")[1]);
      }
      let hour = 0;
      let A = "AM";
      if(Math.floor(num / 60) > 12) {
        hour = this.checkTime(Math.floor(num / 60) - 12);
        A = "PM";
      } else {
        if(Math.floor(num / 60) == 0) {
          hour = 12;
        } else if(Math.floor(num / 60) == 12) {
          hour = 12;
          A = "PM";
        } else {
          hour = this.checkTime(Math.floor(num / 60));
        }
      }
      let minute = this.checkTime(num % 60);
      let out_time = hour + ":" + minute + " " + A;
      return out_time;
    },
    getMinuteTime(in_time, out_time) {
      // let in_minute = parseInt(in_time.split(":")[0]) * 60 + parseInt(in_time.split(":")[1]);
      // if(in_time.includes('AM') && parseInt(in_time.split(":")[0]) == 12) {
      //   in_minute = parseInt(in_time.split(":")[1]);
      // }
      // if(in_time.includes('PM')) {

      //   in_minute = (parseInt(in_time.split(":")[0]) + 12) * 60 + parseInt(in_time.split(":")[1]);
      // }

      // let out_minute = parseInt(out_time.split(":")[0]) * 60 + parseInt(out_time.split(":")[1]);
      // if(out_time.includes('AM') && parseInt(out_time.split(":")[0]) == 12) {
      //   out_minute = parseInt(out_time.split(":")[1]);
      // }
      // if(out_time.includes('PM')) {
      //   out_minute = (parseInt(out_time.split(":")[0]) + 12) * 60 + parseInt(out_time.split(":")[1]);
      // }
      // return in_minute + ", " + out_minute;
      return this.getMinute(in_time) + ", " + this.getMinute(out_time);
    },
    isActive(day_string, value) {
      return typeof day_string == "string" && day_string.includes(value);
    },
    closePopup() {
      this.working_day_temp = this.working_day;
      this.days_temp = JSON.parse(JSON.stringify(this.days));
      this.openEditPopup = false;
    },
    editWorkingHour() {
      this.openEditPopup = true;
    },
    setInTime(event, day) {
      // day.time[0] = moment(event[0]).format("HH:mm");
      for (let i = 0; i < this.days_temp.length; i++) {
        if (day.value == this.days_temp[i].value) {
          this.days_temp[i].time[0] = moment(event[0]).format("HH:mm");
          // console.log(moment(event[0]).format("HH:mm A"))
        }
      }
    },
    setOutTime(event, day) {
      // day.time[1] = moment(event[0]).format("HH:mm");
      for (let i = 0; i < this.days_temp.length; i++) {
        if (day.value == this.days_temp[i].value) {
          this.days_temp[i].time[1] = moment(event[0]).format("HH:mm");
          // console.log(moment(event[0]).format("HH:mm A"))
        }
      }
    },
    changeStatus(day) {
      if (this.isActive(this.working_day_temp, day.value)) {
        this.working_day_temp = this.working_day_temp.replace("," + day.value, "");
        this.working_day_temp = this.working_day_temp.replace(day.value + ",", "");
        this.working_day_temp = this.working_day_temp.replace(day.value, "");
      } else {
        this.working_day_temp = this.working_day_temp + "," + day.value;
      }
    },
    switchActive(day) {
      for (let i = 0; i < this.days_temp.length; i++) {
        if (day.value == this.days_temp[i].value) {
          this.days_temp[i].active = day.active;
        }
      }
    },
    hasEmptyTime() {
      for(let i = 0; i < this.days_temp.length; i++) {
        if(this.days_temp[i].time[0] == '' || this.days_temp[i].time[1] == ''){
          return true;
        }
      }
      return false;
    },
    openLoadingInDiv(){
      this.$vs.loading({
        container: '#app',
        scale: 0.8
      })
      if (this.loadTime) {
        clearTimeout(this.loadTime);
        this.loadTime = null;
      }
      this.isOpenLoading = true;
      this.loadTime = setTimeout( ()=> {
        if(this.isOpenLoading) {
          this.closeLoading();
          // this.$vs.notify({
          //   title:'Notification',
          //   text: 'Update working hour failed',
          //   color:'danger',
          //   position:'top-right'})
          this.$vs.dialog({
            color: 'danger',
            title: 'Notification',
            text: 'Update working hour failed',
            acceptText: 'OK'
          })
        }
      }, 10000);
      // setTimeout( ()=> {
      //   this.$vs.loading.close('#staff-list > .con-vs-loading')
      // }, 500);

    },
    closeLoading() {
      this.$vs.loading.close('#app > .con-vs-loading');
      this.isOpenLoading = false;
    },
    saveChanges() {
      // console.log(this.days)
      this.checkValidTime();
      if(this.hasErr == false) {
        if(!this.isOpenLoading) {
          this.openLoadingInDiv();
        }
        this.working_day = this.working_day_temp;
        this.days = JSON.parse(JSON.stringify(this.days_temp));
        const obj = {
          id: this.activeStaffData.user_id,
          working_day: this.working_day,
          mo: this.getMinuteTime(this.days[0].time[0], this.days[0].time[1]),
          tu: this.getMinuteTime(this.days[1].time[0], this.days[1].time[1]),
          we: this.getMinuteTime(this.days[2].time[0], this.days[2].time[1]),
          th: this.getMinuteTime(this.days[3].time[0], this.days[3].time[1]),
          fr: this.getMinuteTime(this.days[4].time[0], this.days[4].time[1]),
          sa: this.getMinuteTime(this.days[5].time[0], this.days[5].time[1]),
          su: this.getMinuteTime(this.days[6].time[0], this.days[6].time[1]),
        }
        // console.log(obj)
        // this.$emit('SaveWorkingHour',obj);
        this.$store.dispatch("staffList/UPDATE_WORKING_HOUR", obj).then(()=>{

          this.closePopup();
          this.closeLoading();
          this.$vs.notify({
            title:'Notification',
            text:'Update Working Hour Success',
            color:'success',
            position:'top-right'})
        })
      } else {
        this.$vs.notify({
          title:'Notification',
          text:'Check input time',
          color:'danger',
          position:'top-right'})
        this.hasErr = false;
      }
      this.$validator.validateAll().then((result) => {
        if(result == false) {
          this.$vs.notify({
            title:'Fail',
            text:'Time is required',
            color:'danger'
          })
        }
      })
    }
  }
};
</script>

<style lang="scss">
  @import '~vue2-timepicker/dist/VueTimepicker.css';
</style>
